"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalInstance = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var ModalComponent_1 = require("./ModalComponent");
var Types_1 = require("./Types");
var ModalInstance = (function (_super) {
    __extends(ModalInstance, _super);
    function ModalInstance(props) {
        var _this = _super.call(this, props) || this;
        _this.showAcknowledgeModal = function (args) {
            return new Promise(function (resolve) {
                _this.initKeyUpWatch(resolve, !!args.isEscapable);
                _this.modal = (react_1.default.createElement(ModalComponent_1.AcknowledgeModal, { buttonLabel: args.buttonLabel || "Ok", callback: _this.handleResolve(resolve), isEscapable: args.isEscapable, containerClassName: args.containerClassName },
                    args.header || react_1.default.createElement(ModalComponent_1.StandardModalHeader, { title: args.title, explainer: args.explainer }),
                    args.body));
                _this.isModalVisible = true;
            });
        };
        _this.showConfirmModal = function (args) {
            return new Promise(function (resolve) {
                _this.initKeyUpWatch(resolve, !!args.isEscapable);
                _this.modal = (react_1.default.createElement(ModalComponent_1.ConfirmModal, { confirmLabel: args.confirmLabel, cancelLabel: args.cancelLabel, callback: _this.handleResolve(resolve), isEscapable: args.isEscapable, confirming: args.confirming, containerClassName: args.containerClassName }, args.header || react_1.default.createElement(ModalComponent_1.StandardModalHeader, { title: args.title, explainer: args.explainer })));
                _this.isModalVisible = true;
            });
        };
        _this.showDeleteModal = function (args) {
            return new Promise(function (resolve) {
                _this.initKeyUpWatch(resolve, !!args.isEscapable);
                _this.modal = (react_1.default.createElement(ModalComponent_1.DeleteModal, { confirmLabel: args.confirmLabel, cancelLabel: args.cancelLabel, callback: _this.handleResolve(resolve), isEscapable: args.isEscapable, confirming: args.confirming, containerClassName: args.containerClassName }, args.header || react_1.default.createElement(ModalComponent_1.StandardModalHeader, { title: args.title, explainer: args.explainer })));
                _this.isModalVisible = true;
            });
        };
        _this.showSimpleModal = function (args) {
            return new Promise(function (resolve) {
                _this.initKeyUpWatch(resolve, !!args.isEscapable);
                _this.modal = (react_1.default.createElement(ModalComponent_1.SimpleModal, { callback: _this.handleResolve(resolve), title: args.title, isEscapable: args.isEscapable, containerClassName: args.containerClassName, contentClassName: args.contentClassName }, args.body));
                _this.isModalVisible = true;
            });
        };
        _this.closeAnyModals = function () {
            _this.isModalVisible = false;
            _this.modal = null;
            $(document).off(KEYUP_WATCH);
        };
        _this.initKeyUpWatch = function (resolve, isEscapable) {
            $(document).on(KEYUP_WATCH, function (event) {
                if (isEscapable !== false && isEscapeKeyPressed(event)) {
                    setTimeout(function () {
                        _this.handleResolve(resolve)(false);
                    });
                }
            });
        };
        _this.handleResolve = function (resolve) {
            return function (result) {
                _this.closeAnyModals();
                resolve(result);
            };
        };
        _this.isModalVisible = false;
        return _this;
    }
    ModalInstance.prototype.componentDidMount = function () {
        this.props.service.setModalInstance(this);
    };
    ModalInstance.prototype.render = function () {
        return (react_1.default.createElement("div", { id: Types_1.modalRootId, className: "modal-instance" }, this.isModalVisible && this.modal));
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], ModalInstance.prototype, "isModalVisible", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], ModalInstance.prototype, "modal", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ModalInstance.prototype, "closeAnyModals", void 0);
    ModalInstance = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], ModalInstance);
    return ModalInstance;
}(react_1.default.Component));
exports.ModalInstance = ModalInstance;
exports.default = ModalInstance;
var KEYUP_WATCH = "keyup.modal";
var isEscapeKeyPressed = function (event) {
    var ESCAPE_KEY_CODE = 27;
    var code = event.keyCode || event.which;
    return code === ESCAPE_KEY_CODE;
};
